import { cssVariables } from "@/utils/utils";
import { Avatar, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import AntIcon from "../../../../../../common/components/icons/AntIcon";
import { AgentCompetenceType } from "../../../../../agent/enums";

type Props = {
  type: AgentCompetenceType;
};

export const CompetencesTypeAvatar = ({ type }: Props) => {
  const { t } = useTranslation();

  const getIcon = () => {
    switch (type) {
      case AgentCompetenceType.TRAINING:
        return (
          <Avatar
            style={{ backgroundColor: cssVariables.colorBlue }}
            size="large"
            shape="square"
            icon={<AntIcon type="read" />}
          />
        );
      case AgentCompetenceType.TEST:
        return (
          <Avatar style={{ backgroundColor: "purple" }} size="large" shape="square" icon={<AntIcon type="audit" />} />
        );
      default:
        return (
          <Avatar
            style={{ backgroundColor: cssVariables.colorOrange }}
            size="large"
            shape="square"
            icon={<AntIcon type="group" />}
          />
        );
    }
  };

  return <Tooltip title={t(`agent.competence.enums.competenceType.${type}`)}>{getIcon()}</Tooltip>;
};
